import React from 'react';
import PropTypes from 'prop-types';
import { FullscreenSidebar } from '@99designs/common/components/Fullscreen';
import SidebarHeader from '@99designs/common/apps/ddo/components/SidebarHeader';
import DesignActions from 'apps/ddo/components/DesignActions';
import SidebarBodyPane from 'apps/ddo/components/SidebarBodyPane';
import WorkOriginDifferentiator from './WorkOriginDifferentiator';
import { DdoCommentProps } from 'apps/ddo/propTypes';
const SIDEBAR_MODE_DEFAULT = 'default';
const SIDEBAR_MODE_LIKES_LIST = 'likes';

export default class DesignDetailsSidebar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activePane: SIDEBAR_MODE_DEFAULT,
            designId: props.design.designId,
        };

        this.handlePaneChange = this.handlePaneChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.design.designId !== prevState.designId) {
            return {
                activePane: SIDEBAR_MODE_DEFAULT,
                designId: nextProps.design.designId,
            };
        }

        return null;
    }

    handlePaneChange(activePane) {
        this.setState({ activePane });
    }

    render() {
        return (
            <FullscreenSidebar.Main>
                <FullscreenSidebar.Header>
                    <SidebarHeader.Main
                        closeOverlayHandler={this.props.closeOverlayHandler}
                        isCloseButtonEnabled={this.props.isInline}
                    >
                        <DesignActions
                            design={this.props.design}
                            activeUser={this.props.activeUser}
                            activePane={this.state.activePane}
                            onLikeCountClick={this.handlePaneChange.bind(
                                this,
                                SIDEBAR_MODE_LIKES_LIST
                            )}
                        />
                        <WorkOriginDifferentiator design={this.props.design} />
                    </SidebarHeader.Main>
                </FullscreenSidebar.Header>
                <FullscreenSidebar.Body>
                    <SidebarBodyPane
                        onPaneChange={this.handlePaneChange}
                        activePane={this.state.activePane}
                        design={this.props.design}
                        activeUser={this.props.activeUser}
                        isLoadingComments={this.props.isLoadingComments}
                        comments={this.props.comments}
                        selectedComment={this.props.selectedComment}
                        selectedCommentStatus={this.props.selectedCommentStatus}
                        selectedCommentEditingLocation={this.props.selectedCommentEditingLocation}
                    />
                </FullscreenSidebar.Body>
            </FullscreenSidebar.Main>
        );
    }
}

DesignDetailsSidebar.contextTypes = {
    intl: PropTypes.object,
};

DesignDetailsSidebar.defaultProps = {
    selectedComment: null,
    selectedCommentStatus: null,
    selectedCommentEditingLocation: null,
};

DesignDetailsSidebar.propTypes = {
    design: PropTypes.object.isRequired,
    closeOverlayHandler: PropTypes.func.isRequired,
    isInline: PropTypes.bool.isRequired,
    activeUser: PropTypes.object.isRequired,
    ...DdoCommentProps,
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/DesignDetailsSidebar.jsx